import { mapState, mapMutations } from "vuex";
import { colors } from "quasar";

const { setBrand } = colors;

export default {
    computed: {
        ...mapState("components", ["pageReference", "colorValue"])
    },
    methods: {
        ...mapMutations("components", ["updateColor"]),
        __loadThemeObject(themeObject) {
            const newColorValueObj = {};
            let hasCustomPrimary;
            if (themeObject.tertiary === "#555") {
                newColorValueObj.tertiary = "#212121";
            }
            if (themeObject.primary === "#027BE3") {
                newColorValueObj.primary = "#3E71D2";
            }
            const customThemeObject = { ...themeObject, ...newColorValueObj };

            Object.entries(customThemeObject).forEach(([color, value]) => {
                this.updateColor({ color, value });
                setBrand(color, value, this.pageReference);
            });

            if (!customThemeObject.accent) {
                const color = "accent";
                let value = "#FFFFFF";
                if (customThemeObject.primary && customThemeObject.primary !== "#3E71D2") {
                    value = customThemeObject.primary;
                    hasCustomPrimary = true;

                    // change tertiary color
                    const customTertiaryColor = "tertiary";
                    const customTertiaryValue = "#FFFFFF";

                    this.updateColor({ color: customTertiaryColor, value: customTertiaryValue });
                    setBrand(customTertiaryColor, customTertiaryValue, this.pageReference);
                }
                this.updateColor({ color, value });
                setBrand(color, value, this.pageReference);

                if (hasCustomPrimary) {
                    this.$root.$emit("loadColors");
                }
            }
        },
        __resetColors() {
            Object.entries(this.colorValue).forEach(([key, data]) => {
                if (data.theme) {
                    this.updateColor({ color: key, value: data.default });
                    setBrand(key, data.default, this.pageReference);
                }
            });
        }
    }
};
